import React, { Component } from 'react';

import { observer } from 'mobx-react';
import { withRouter, Link } from 'react-router-dom';

import Loader from '../../components/Loader';
import { cancelUserSubscription } from '../../actions/membershipActions';
import membershipStore from '../../stores/membershipStore';
import Col12 from './components/Col12';
import { T } from '../../stores/textStore';

class UserSubscriptionCancellationView extends Component {
	componentDidMount() {
		membershipStore.alerts.replace([]);
	}

	handleCancelClick = (event) => {
		event.preventDefault();
		const { id } = this.props.match.params;
		cancelUserSubscription(id)
		.then(() => {
			const { history } = this.props;
			history.push('/');
			return null;
		})
	}	

	render() {	
		if (!membershipStore.isDataLoaded()) {
			return (
				<Col12>
					<Loader message={membershipStore.processingMessage.get()} />
				</Col12>
			);
		}
		if (membershipStore.processing.get()) {
			return (
				<Col12>
					<Loader message={membershipStore.processingMessage.get()} />
				</Col12>
			);
		}				
		return (
			<div className="container mt-4">
				<div className="row">
					<div className="col-12">
						<p>
							{T('Are you sure you want to cancel your membership?')}
						</p>
						<Link 
								to="/" 
								className="btn btn-secondary mb-3 mx-1"									
						>
							{T('No - Keep My Membership')}
						</Link>						
						<button 
								type='button' 
								onClick={this.handleCancelClick} 
								className="btn btn-danger mb-3 mx-1"
						>
							{T('Yes - Cancel My Membership')}
						</button>					
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(observer(UserSubscriptionCancellationView));



// WEBPACK FOOTER //
// ./src/views/membership/UserSubscriptionCancellationView.js